// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*   muted country fill */
.em--alpha .em-cntrg,
.em--alpha .em-cntrg {
    fill: #f2f2f2;
}

/*   muted nuts fill */
.em--alpha .em-nutsrg,
.em--alpha .em-nutsrg {
    fill: #fdfdfd;
}

/* Coastlines should not be drawn for choropleths, however for alpha maps with white regions they can be necessary */
.em--alpha .em-bn-co {
    stroke: grey;
    stroke-width: 0.1px;
}
`, "",{"version":3,"sources":["webpack://./src/css/layers/alpha.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;;IAEI,aAAa;AACjB;;AAEA,sBAAsB;AACtB;;IAEI,aAAa;AACjB;;AAEA,oHAAoH;AACpH;IACI,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":["/*   muted country fill */\r\n.em--alpha .em-cntrg,\r\n.em--alpha .em-cntrg {\r\n    fill: #f2f2f2;\r\n}\r\n\r\n/*   muted nuts fill */\r\n.em--alpha .em-nutsrg,\r\n.em--alpha .em-nutsrg {\r\n    fill: #fdfdfd;\r\n}\r\n\r\n/* Coastlines should not be drawn for choropleths, however for alpha maps with white regions they can be necessary */\r\n.em--alpha .em-bn-co {\r\n    stroke: grey;\r\n    stroke-width: 0.1px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
